import { type UseQueryResult, useQuery } from 'react-query';
import {
  AdvisorPartnerEnrollmentConfigService,
  type Wealthlane_Dtos_AdvisorApi_AdvisorPartnerEnrollmentConfigDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetAdvisorPartnerEnrollmentConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string,
  enabled = true,
): UseQueryResult<Wealthlane_Dtos_AdvisorApi_AdvisorPartnerEnrollmentConfigDto | null | undefined, unknown> => {
  return useQuery(
    ['getAdvisorPartnerEnrollmentConfig', companyId ?? 'self'],
    async () => {
      const result = await handleRequest(
        AdvisorPartnerEnrollmentConfigService.getApiIdentityApiAppAdvisorPartnerEnrollmentConfig(
          companyId,
        ),
      );
      return result ?? null;
    },
    {
      enabled,
    },
  );
};

export default useGetAdvisorPartnerEnrollmentConfig;
